import { TableInformation, CompleteTableInformation } from '@mysrc/models/approval-hub.model';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const TABLE_INFO = createActionGroup({
  source: 'columns',
  events: {
    'Table Details': emptyProps(),
    'Table Details Success': props<{ data: TableInformation[] }>(),
    'Load All Categories': props<{ category: string, tableIndexes: number[] }>(),
    'Fetch Config': emptyProps(),
    'Fetch Config Success': props<{ data: CompleteTableInformation[], name?: string }>(),
    'Select Category': props<{ name: string }>(),
    'Select Sub Category': props<{ name: string }>(),
  },
});

export const REQUEST_ACTION = createActionGroup({
  source: 'request',
  events: {
    'Approve Request': props<{
      data: {
        tableWholeData: TableInformation;
        sys_id: string;
        comments: string;
        formData: { [k: string]: any };
      };
    }>(),
    'Approve Request Success': props<{ slaSummaryId: string }>(),
    'Approve Request Failure': props<{ message: string }>(),
    'Reject Request': props<{
      data: {
        tableWholeData: TableInformation;
        sys_id: string;
        comments: string;
        formData: { [k: string]: any };
      };
    }>(),
    'Reject Request Success': props<{ slaSummaryId: string }>(),
    'Reject Request Failure': props<{ message: string }>(),
  },
});

export const ATTACHMENT_ACTION = createActionGroup({
  source: 'attachment',
  events: {
    'Fetch Attachments': props<{ sysId: string }>(),
    'Fetch Attachments Success': props<{ attachments: any[] }>(),
    'Fetch Attachments Failure': props<{ message: string }>(),
    'Upload Attachment': props<{ file: File; sysId: string }>(),
    'Upload Attachment Success': props<{ attachment: any }>(),
    'Upload Attachment Failure': props<{ message: string }>(),
    'Delete Attachment': props<{ sysId: string }>(),
    'Delete Attachment Success': props<{ sysId: string }>(),
    'Delete Attachment Failure': props<{ message: string }>(),
  },
});
